export const data = {
  buttons: [
    {
      label: 'Fewer than 7 days',
      id: 'fewer-than-7-days',
    },
    {
      label: 'Between 7 and 14 days',
      id: 'between-7-and-14-days',
    },
    {
      label: 'More than 14 days',
      id: 'more-than-14-days',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/3c07b75605a6-tooliconclock.jpg',
  },
  title: 'How long before your flight was due to depart were you told it was cancelled?',
}
